import React from 'react'
import cx from 'classnames'

import { Href } from 'components/navigation'
import { Image, Text } from 'components/dataDisplay'

import s from './ServiceCardSmall.scss'


type ServiceCardSmallProps = {
  className?: string
  to: string
  title: string
  image: string
}

const ServiceCardSmall: React.FC<ServiceCardSmallProps> = (props) => {
  const { className, to, title, image } = props

  return (
    <Href className={className} to={to}>
      <div className={cx(s.serviceCard)}>
        <div className={cx(s.gradientBackground, s.imageWrapper, 'overflow-hidden radius-16')}>
          <Image className={cx('radius-16 w-full')} src={image} alt={title}/>
        </div>
        <Text
          className={cx(s.text, 'mt-16px text-center flex-none overflow-ellipsis')}
          message={title}
          size="c16"
          color="titanic"
        />
      </div>
    </Href>
  )
}


export default ServiceCardSmall
